const prefix = "[CREATIVE_MAPPINGS_OVERVIEW]";

export default {
    FETCH_CREATIVE_MAPPINGS_REQUEST: `${prefix} FETCH_CREATIVE_MAPPINGS_REQUEST`,
    FETCH_CREATIVE_MAPPINGS_SUCCESS: `${prefix} FETCH_CREATIVE_MAPPINGS_SUCCESS`,
    FETCH_CREATIVE_MAPPINGS_FAILED: `${prefix} FETCH_CREATIVE_MAPPINGS_FAILED`,
    CREATE_CREATIVE_MAPPING_REQUEST: `${prefix} CREATE_CREATIVE_MAPPING_REQUEST`,
    CREATE_CREATIVE_MAPPING_SUCCESS: `${prefix} CREATE_CREATIVE_MAPPING_SUCCESS`,
    CREATE_CREATIVE_MAPPING_FAILED: `${prefix} CREATE_CREATIVE_MAPPING_FAILED`,
    UPDATE_CREATIVE_MAPPING_REQUEST: `${prefix} UPDATE_CREATIVE_MAPPING_REQUEST`,
    UPDATE_CREATIVE_MAPPING_SUCCESS: `${prefix} UPDATE_CREATIVE_MAPPING_SUCCESS`,
    UPDATE_CREATIVE_MAPPING_FAILED: `${prefix} UPDATE_CREATIVE_MAPPING_FAILED`,
    DELETE_CREATIVE_MAPPING_REQUEST: `${prefix} DELETE_CREATIVE_MAPPING_REQUEST`,
    DELETE_CREATIVE_MAPPING_SUCCESS: `${prefix} DELETE_CREATIVE_MAPPING_SUCCESS`,
    DELETE_CREATIVE_MAPPING_FAILED: `${prefix} DELETE_CREATIVE_MAPPING_FAILED`,
    TOGGLE_ROW_EDIT: `${prefix} TOGGLE_ROW_EDIT`,
    UNSET_CREATIVE_MAPPINGS_ROW_EDIT: `${prefix} UNSET_CREATIVE_MAPPINGS_ROW_EDIT`,
};
